import { courseAccessMethods } from "@api/selectTypes/courseAccessMethods/path";
import { genders } from "@api/selectTypes/genders/path";
import { userRoles } from "@api/selectTypes/userRoles/path";
import { subjectCategories } from "@api/selectTypes/subjectCategories/path";
import { courseContentAccessMethods } from "@api/selectTypes/courseContentAccessMethods/path";
import { examAccessTimeRestrictionStates } from "@api/selectTypes/examAccessTimeRestrictionsStates/path";
import { examAttemptStates } from "@api/selectTypes/examAttemptStates/path";
import { examCategories } from "@api/selectTypes/examCategories/path";
import { examDurationCalculationMethods } from "@api/selectTypes/examDurationCalculationMethods/path";
import { examStates } from "@api/selectTypes/examStates/path";
import { messageKinds } from "@api/selectTypes/messageKinds/path";
import { questionDifficultyLevels } from "@api/selectTypes/questionDifficultyLevels/path";
import { questionFormats } from "@api/selectTypes/questionFormats/path";
import { reviewApprovalStates } from "@api/selectTypes/reviewApprovalStates/path";
import { studentEducationLevel } from "@api/selectTypes/studentEducationLevel/path";
import { teacherEducationLevel } from "@api/selectTypes/teacherEducationLevel/path";

export const selectTypes = {
  courseAccessMethods,
  courseContentAccessMethods,
  examAccessTimeRestrictionStates,
  examAttemptStates,
  examCategories,
  examDurationCalculationMethods,
  examStates,
  messageKinds,
  questionDifficultyLevels,
  questionFormats,
  genders,
  userRoles,
  subjectCategories,
  reviewApprovalStates,
  studentEducationLevel,
  teacherEducationLevel,
};
